(() => {
  const root = (window.KOMModules = window.KOMModules || {});

  root.setupScrollTopButton = () => {
    const button = document.querySelector('[data-scroll-top]');
    if (!button) {
      return;
    }

    const refresh = () => {
      const shouldShow = window.scrollY > 420;
      button.hidden = !shouldShow;
      button.classList.toggle('is-visible', shouldShow);
    };

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  };
})();
